// extracted by mini-css-extract-plugin
export var closeButton = "_3s-3";
export var header = "_3s-0";
export var link = "_3s-1";
export var retryButton = "_3s-2";